// extracted by mini-css-extract-plugin
export var locationsContainer = "_zi-2";
export var locationsTextContainer = "_zi-1";
export var mapContainer = "_zi-0";